import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const ChartOfAccounts = () => {
  return <ErpTablePage moduleKey="coa" />;
};

export default ChartOfAccounts;